export default "__VITE_ASSET__Cv6N_d_6__";